module.exports = __webpack_public_path__ + "static/media/logoOnly.e3e9291a.svg";